import TrackElements from '@capsule/track-elements'

export default class ArticlePeopleNews {
	articlePeopleNewsListItem: NodeListOf<HTMLAnchorElement>

	constructor() {
		this.articlePeopleNewsListItem = document.querySelectorAll(
			'#articlePeopleNews .contentCard'
		)
	}

	init() {
		this.initTrackingElements()
	}

	initTrackingElements() {
		if (this.articlePeopleNewsListItem.length) {
			const trackingEntries = [...this.articlePeopleNewsListItem].map((listItem, index) => ({
				element: listItem,
				display: {
					event: 'navigation_display',
					navigation_type: 'news-people'
				},
				click: {
					event: 'navigation_click',
					navigation_type: 'news-people',
					navigation_name: `article-${index + 1}`
				}
			}))
			const trackElements = new TrackElements(trackingEntries)
			trackElements.init()
		}
	}
}
